'use client';

import {
  validateAccountNumber,
  validateEmail,
  validateLandlineNumber,
  validatePassword,
} from './validate';

/**
 * @name handleChange
 * @description - Function to handle onchange event on user input field
 * @param {string} name - Name of text field
 * @param {string} value - Value of the user entered field
 * @param {object} setErrors - Sets the errors based on validation
 * @param {object} setValues - Sets the values on user input
 */
export const handleChange = (name, value, setErrors, setValues) => {
  let error = '';
  switch (name) {
    case 'email':
      error = validateEmail(value);
      break;
    case 'password':
      error = validatePassword(value);
      break;
    case 'accountNumber':
      error = validateAccountNumber(value);
      break;
    case 'landLineNumber':
      error = validateLandlineNumber(value);
      break;
    default:
      error = '';
  }
  setValues(prev => ({ ...prev, [name]: value }));
  setErrors(prevErrors => ({
    ...prevErrors,
    [name]: error,
  }));
};
